import type { HeroDefinition, HeroId } from '../types';
import { bramble } from './bramble';
import { cleo } from './cleo';
import { otto } from './otto';
import { pip } from './pip';
import { barley, bruno, dash, fern, juniper, lumi, marlow, posy, thistle, tuck, wren } from './roster';

export const HERO_LIST: readonly HeroDefinition[] = [
  pip,
  bruno,
  tuck,
  bramble,
  thistle,
  marlow,
  cleo,
  wren,
  juniper,
  otto,
  lumi,
  barley,
  fern,
  posy,
  dash,
];

export const HEROES: Record<HeroId, HeroDefinition> = {
  pip,
  bruno,
  tuck,
  bramble,
  thistle,
  marlow,
  cleo,
  wren,
  juniper,
  otto,
  lumi,
  barley,
  fern,
  posy,
  dash,
};

export { pip, bramble, cleo, otto, bruno, tuck, thistle, marlow, wren, juniper, lumi, barley, fern, posy, dash };
